export const iconFontAwesomeHolidaysSnowman = (
	<i className="fa-solid fa-snowman"></i>
);
